import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { EventEmitter } from 'eventemitter3';
export var TilePickService = /*#__PURE__*/function (_EventEmitter) {
  _inherits(TilePickService, _EventEmitter);

  var _super = _createSuper(TilePickService);

  function TilePickService(parent, rendererService, pickingService, children, tileRenderService) {
    var _this;

    _classCallCheck(this, TilePickService);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "isLastPicked", false);

    _this.parent = parent;
    _this.rendererService = rendererService;
    _this.pickingService = pickingService;
    _this.children = children;
    _this.tileRenderService = tileRenderService;
    return _this;
  }

  _createClass(TilePickService, [{
    key: "pick",
    value: function pick(layers, target) {
      var _this2 = this;

      // Tip: 在进行拾取渲染的时候也需要先渲染一遍父组件然后再渲染子组件
      //  如需要在 栅格瓦片存在 Mask 的时候发生的拾取，那么就需要先渲染父组件（渲染父组件的帧缓冲）
      this.tileRenderService.renderMask(this.parent);
      var isPicked = layers.filter(function (layer) {
        return _this2.parent.needPick(target.type) && layer.inited && layer.isVisible();
      }).some(function (layer) {
        layer.hooks.beforePickingEncode.call();

        if (layer.masks.length > 0) {
          // 清除上一次的模版缓存
          _this2.rendererService.clear({
            stencil: 0,
            depth: 1,
            framebuffer: null
          });

          layer.masks.map(function (m) {
            m.hooks.beforeRender.call();
            m.render();
            m.hooks.afterRender.call();
          });
        }

        layer.renderModels(true);
        layer.hooks.afterPickingEncode.call();

        var layerPicked = _this2.pickingService.pickFromPickingFBO(layer, target); // RasterLayer 不参与拾取后的 shader 计算


        if (layerPicked && _this2.parent.type !== 'RasterLayer') {
          _this2.emit('pick', {
            type: target.type,
            pickedColors: _this2.pickingService.pickedColors,
            layer: layer
          });

          _this2.pickingService.pickedTileLayers = [_this2.parent];
        }

        return layerPicked;
      });

      if (this.parent.type !== 'RasterLayer' && !isPicked && this.isLastPicked && target.type !== 'click') {
        // 只有上一次有被高亮选中，本次未选中的时候才需要清除选中状态
        this.pickingService.pickedTileLayers = [];
        this.emit('unpick', {});
        this.beforeHighlight([0, 0, 0]);
      }

      this.isLastPicked = isPicked;
      return isPicked;
    }
  }, {
    key: "clearPick",
    value: function clearPick() {
      this.children.filter(function (child) {
        return child.inited && child.isVisible();
      }).map(function (layer) {
        layer.hooks.beforeSelect.call([0, 0, 0]);
      });
      this.pickingService.pickedTileLayers = [];
    }
  }, {
    key: "beforeHighlight",
    value: function beforeHighlight(pickedColors) {
      this.children.filter(function (child) {
        return child.inited && child.isVisible();
      }).map(function (child) {
        child.hooks.beforeHighlight.call(pickedColors);
      });
    }
  }, {
    key: "beforeSelect",
    value: function beforeSelect(pickedColors) {
      this.children.filter(function (child) {
        return child.inited && child.isVisible();
      }).map(function (layer) {
        layer.hooks.beforeSelect.call(pickedColors);
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.removeAllListeners();
    }
  }]);

  return TilePickService;
}(EventEmitter);